<template>
  <!-- {{ auction }} {{ auction.increment_count }} - {{ auction.team_size }} -->
  <div class="container container-fluid mb-2">
    <div class="row mt-2">
      <div class="col">
        <i
          class="bi bi-x-lg text-danger float-start"
          @click="clearAuction()"
        ></i>
      </div>
    </div>
    <div class="row">
      <div class="row" v-if="msg.length">
        <ul class="list-group">
          <li class="list-group-item bg-info" v-for="m in msg" :key="m">
            {{ m }}
          </li>
        </ul>
      </div>
      <div class="row" v-if="err.length">
        <ul class="list-group">
          <li class="list-group-item bg-warning" v-for="e in err" :key="e">
            {{ e }}
          </li>
        </ul>
      </div>
      <div class="row d-flex align-items-center">
        <div class="col">
          <button
            class="btn btn-success btn-sm"
            v-if="auction.active"
            @click="toggleActive()"
          >
            Active
          </button>
          <button class="btn btn-danger btn-sm" v-else @click="toggleActive()">
            Inactive
          </button>
        </div>
        <div class="col">
          <AuctionLogo
            :auction="auction"
            @pic-updated="fetchAuction()"
          ></AuctionLogo>
        </div>
        <div class="col-3 fw-bold">
          {{ auction.name }}
        </div>
      </div>
    </div>
    <div class="row">
      <SettingsComponent></SettingsComponent>
    </div>
    <div class="row">
      <PoolsComponent></PoolsComponent>
    </div>
    <div class="row">
      <TeamsComponent></TeamsComponent>
    </div>
    <div class="row">
      <PlayersComponent></PlayersComponent>
    </div>
  </div>
  <div class="row mb-2">
    <div class="col d-flex justify-content-around">
      <i
        class="bi bi-trash text-danger tinytxt float-end"
        @click="toggleDeleteAll()"
        v-if="!show_delete"
      ></i>
      <span
        v-else
        class="border bg-success rounded tinytxt text-white fw-bold"
        @click="toggleDeleteAll()"
        >Cancel</span
      >
    </div>
    <div class="col d-flex justify-content-around" v-if="show_delete">
      <button class="btn btn-sm btn-primary" @click="cautionAction('onlysold')">
        OnlySoldPlayers
      </button>
      <button class="btn btn-sm btn-danger" @click="cautionAction('allsold')">
        AllPlayers
      </button>
    </div>
  </div>
  <div class="row" v-if="caution_action">
    <div class="col">
      <button
        class="btn btn-sm btn-primary tinytxt"
        @click="clearAllSold()"
        v-if="caution_action == 'onlysold'"
      >
        Yes! Reset all SOLD players. CANNOT BE UNDONE!!
      </button>

      <button
        class="btn btn-sm btn-danger tinytxt"
        @click="clearAllData()"
        v-if="caution_action == 'allsold'"
      >
        Yes! Delete ALL data. CANNOT BE UNDONE!!
      </button>
    </div>
  </div>
</template>
<script setup>
import { onMounted, ref } from "vue";
import { useStore } from "@/store/index";
import supabase from "@/supabase/config";
import PlayersComponent from "./PlayersComponent.vue";
import PoolsComponent from "./PoolsComponent.vue";
import TeamsComponent from "./TeamsComponent.vue";
import SettingsComponent from "./SettingsComponent.vue";
import AuctionLogo from "./AuctionLogo.vue";
const store = useStore();
const err = ref([]);
const msg = ref([]);
const auction = ref({});
const show_delete = ref(false);
const caution_action = ref("");
const cautionAction = (str) => {
  if (caution_action.value != str) {
    caution_action.value = str;
  } else {
    caution_action.value = "";
  }
};
const toggleDeleteAll = () => {
  show_delete.value = !show_delete.value;
};
onMounted(() => {
  fetchAuction();
});
const fetchAuction = async () => {
  auction.value = {};
  let { data: auctions, error } = await supabase
    .from("auctions")
    .select("*")
    .eq("auctioneer_id", store.user.id)
    .eq("id", store.live_auction);
  auction.value = auctions[0];
};
const clearAuction = () => {
  store.clearAuction();
};
const updateAuction = async () => {
  console.log(auction.value.increment_count);
  checkConditions();
  if (!err.value.length) {
    const updateObj = {
      name: auction.value.name,
      wallet_size: auction.value.wallet_size,
      team_size: auction.value.team_size,
      bid_increment: auction.value.bid_increment,
      increment_count: auction.value.increment_count,
      // active: false,
    };
    console.log(updateObj.increment_count);
    const { data, error } = await supabase
      .from("auctions")
      .update(updateObj)
      .eq("id", auction.value.id)
      .select();
    console.log("data=>", data);
    if (!error) {
      msg.value.push("Auction updated!");
      fetchAuction();
    } else {
      msg.value.push(error.message);
    }
    setTimeout(() => {
      msg.value = [];
    }, 1000);
  }
};
const checkConditions = () => {
  err.value = [];
  if (!auction.value.name) {
    err.value.push("Auction name required");
  }
  if (!auction.value.wallet_size) {
    err.value.push("Wallet amount required");
  }
  if (!isNumber(auction.value.wallet_size)) {
    err.value.push("Wallet should be number");
  }
  if (!auction.value.bid_increment) {
    err.value.push("Increment amount required");
  }
  if (!isNumber(auction.value.bid_increment)) {
    err.value.push("Increment should be number");
  }
  if (!auction.value.team_size) {
    err.value.push("Team size required");
  }
  if (!isNumber(auction.value.team_size)) {
    err.value.push("Team size should be number");
  }
};
function isNumber(value) {
  return typeof value === "number";
}
const toggleActive = async () => {
  const { data, error } = await supabase
    .from("auctions")
    .update({ active: !auction.value.active })
    .eq("id", auction.value.id)
    .select();
  if (!error) {
    fetchAuction();
    msg.value.push("Auction updated!");
    setTimeout(() => {
      msg.value = [];
    }, 1000);
  }
};
const clearAllData = async () => {
  const { data, error } = await supabase
    .from("players")
    .update({ team_id: null, sale_price: null, sold_at: null })
    .eq("auction_id", store.live_auction)
    .select();

  const { error_ } = await supabase
    .from("bids")
    .delete()
    .eq("auction_id", store.live_auction);

  //clear out live player
  const { datae, errore } = await supabase
    .from("auctions")
    .update({ live_player_id: null })
    .eq("id", store.live_auction)
    .select();
  //reset team wallets

  const { datar, errorr } = await supabase
    .from("teams")
    .update({ wallet: auction.value.wallet_size })
    .eq("auction_id", store.live_auction)
    .select();

  //closeAuction();
  show_delete.value = false;
};
const clearAllSold = async () => {
  var sold_players = [];
  let { data: players, error24 } = await supabase
    .from("players")
    .select("*")
    .eq("auction_id", store.live_auction)
    .gt("sale_price", 0);
  sold_players = players;
  console.log(sold_players);

  sold_players.forEach(async (p) => {
    const { data, error } = await supabase
      .from("players")
      .update({ team_id: null, sale_price: null, sold_at: null })
      .eq("id", p.id)
      .select();
  });

  const { error_ } = await supabase
    .from("bids")
    .delete()
    .eq("auction_id", store.live_auction);

  //clear out live player
  const { datae, errore } = await supabase
    .from("auctions")
    .update({ live_player_id: null })
    .eq("id", store.live_auction)
    .select();
  //reset team wallets

  const { datar, errorr } = await supabase
    .from("teams")
    .update({ wallet: auction.value.wallet_size })
    .eq("auction_id", store.live_auction)
    .select();

  //closeAuction();

  show_delete.value = false;
};
</script>
